import { Routes } from '@angular/router';
import {
  CmsPageComponent,
  cmsPageTemplateResolver,
  cmsSeoDataResolver,
} from '@domgen/dgx-fe-cms';
import { hasSelectedApplianceGuard } from './guards/has-selected-appliance/has-selected-appliance.guard';

export const YOUR_APPLIANCE_ROUTES: Routes = [
  {
    path: '',
    component: CmsPageComponent,
    canActivate: [hasSelectedApplianceGuard],
    resolve: {
      cmsPageTemplate: cmsPageTemplateResolver,
      seoData: cmsSeoDataResolver,
    },
  },
];
